export default "/images/logo.svg?7f5390bc71df4c764710e53cf1c10e4f";